import React from "react";
import "./Footer.scss";
import Logo from "../../assets/images/solucionarte_logo-15.png";
import { Link } from "react-router-dom";
import Copyright from "../Copyright/Copyright";

const Footer = (props) => {

    const img = "https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500";
    const title = "Elegi la persona adecuada";
    const description = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint dicta temporibus aperiam. Labore possimus quod placeat, dignissimos ab incidunt aut voluptatem? Sit ab asperiores fugiat optio animi, dolore autem, veritatis dolores aliquam quo corrupti libero aliquid minima itaque facilis enim.";
    const image = "https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500";

    const data = { image, title, description, img }

    return (
        <div id="footer">

            <div className="footer__header">
                <Link to="/">
                    <div className="footer__header--container">
                        <img src={Logo} alt="Solucionarte" />
                    </div>
                </Link>
            </div>


            <div className='footer__body'>


                <div className="footer__body--usuarios">
                    <h4>Usuarios</h4>
                    <Link className="footer__link" to="blog">Blog</Link>
                    <Link className="footer__link" to="contacto">Contacto</Link>
                    <Link className="footer__link" to="como-funciona-usuarios" >¿Cómo funciona?</Link>
                    <Link exact className="footer__link" to={{
                        pathname: `/elegi-la-persona-adecuada`, state: { data }
                    }}>Tips para eligir prestadores</Link>
                    <Link className="footer__link" to="términos-y-condiciones">Términos y condiciones</Link>
                    <Link className="footer__link" to="política-de-privacidad">Politica de privacidad</Link>
                </div>


                <div className="footer__body--social">
                    <h4>Redes Sociales</h4>
                    <ul>
                        <li>
                            <a href={props.data ? props.data.facebook : 'https://www.facebook.com/Solucionarte-100295795830836/'} target="_blank" rel="noreferrer">
                                <i className='fab fa-facebook'></i>
                            </a>
                        </li>
                        <li>
                            <a href={props.data ? props.data.instagram : 'https://instagram.com/solucionartelapampa?utm_medium=copy_link'} target="_blank" rel="noreferrer">
                                <i className='fab fa-instagram'></i>
                            </a>
                        </li>
                        <li>
                            <a href={props.data ? props.data.twitter : 'https://twitter.com/SolucionarteP?t=lu2cBVafawly9s9K2a_hjw&s=09'} target="_blank" rel="noreferrer">
                                <i className='fab fa-twitter'></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="footer__body--prestadores">
                    <h4>Prestadores</h4>
                    <Link className="footer__link" to="contacto">Contacto</Link>
                    <Link className="footer__link" to="registro">Registro</Link>
                    <Link className="footer__link" to="como-funciona-prestadores">¿Cómo funciona?</Link>
                    <Link className="footer__link" to="información-para-prestadores" >Información para prestadores</Link>
                </div>

            </div>
            <Copyright />

        </div>
    )
}

export default Footer
